import { FC } from 'react';
import { IconProps } from '@base/icon/interface';
import { SVG } from '@base/icon/SVG';

export const IconMinus: FC<IconProps> = props => (
    <SVG
        {...props}
        path="M170.666667 512a42.666667 42.666667 0 0 1 42.666666-42.666667h597.333334a42.666667 42.666667 0 0 1 0 85.333334H213.333333A42.666667 42.666667 0 0 1 170.666667 512z"
    />
);